import { render, staticRenderFns } from "./AllocationTissue.vue?vue&type=template&id=f806cc00"
import script from "./AllocationTissue.vue?vue&type=script&lang=js"
export * from "./AllocationTissue.vue?vue&type=script&lang=js"
import style0 from "./AllocationTissue.vue?vue&type=style&index=0&id=f806cc00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports